<template>
  <div class="py-3 compilatore-blocchi">
    <div v-if="template" class="">
      <ValidationObserver v-slot="{ invalid }">
      <b-form @submit.prevent="sendForm">
        <nav
          v-if="blockGroups.length > 0"
          class="block-pills-nav"
          :aria-label="$t('CompilatoreQuestionarioInBlocks.naviga_blocchi')"
        >
          <ul class="block-pills-list" role="list">
            <li
              v-for="(group, groupindex) in blockGroups"
              :key="'pill_' + groupindex"
              role="listitem"
              class="block-pill-item"
            >
              <b-button
                pill
                size="sm"
                :variant="
                  groupindex === tabInView ? 'secondary' : 'outline-secondary'
                "
                :disabled="isPillDisabled(groupindex, invalid)"
                :aria-current="groupindex === tabInView ? 'step' : null"
                :aria-label="
                  $t('CompilatoreQuestionarioInBlocks.vai_al_blocco', {
                    blocco: blockTitle(groupindex),
                  })
                "
                @click="goToBlock(groupindex)"
                >{{ blockTitle(groupindex) }}</b-button
              >
            </li>
          </ul>
        </nav>
        <b-row
          v-if="pillsOverflow"
          class="justify-content-start align-items-center mx-0 mb-3 pl-1"
        >
          <b-button
            size="sm"
            class="block-nav-arrow rounded-circle mr-2"
            variant="outline-secondary"
            :disabled="!canScrollLeft"
            :aria-label="$t('CompilatoreQuestionarioInBlocks.scorri_sinistra')"
            @click="scrollPillsLeft"
          >
            <b-icon icon="chevron-left" aria-hidden="true"></b-icon>
          </b-button>
          <b-button
            size="sm"
            class="block-nav-arrow rounded-circle"
            variant="outline-secondary"
            :disabled="!canScrollRight"
            :aria-label="$t('CompilatoreQuestionarioInBlocks.scorri_destra')"
            @click="scrollPillsRight"
          >
            <b-icon icon="chevron-right" aria-hidden="true"></b-icon>
          </b-button>
        </b-row>
        <b-row cols="1" class="align-items-end">
          <transition-group name="list" mode="out-in" appear>
            <template v-if="blockGroups.length > 0">
              <b-tabs
                content-class="mt-3"
                key="questiongrouptab"
                v-model="tabInView"
                nav-class="d-none"
              >
                <template v-for="(group, groupindex) in blockGroups">
                  <b-tab
                    :key="'block_group' + groupindex"
                    :title="blockTitle(groupindex)"
                  >
                    <template v-for="(domanda, ind) in group">
                      <template v-if="canBeShown(domanda)">
                        <!-- <p :key="'dpt' + ind">
                          {{ domanda }}
                        </p> -->

                        <!-- //ricognizione //ricognizione patologie //files //opzioni
                (select o checkbox) -->

                        <template v-if="domanda.o">
                          <template v-if="domanda.o === 'ricognizione'">
                            <CompilatoreRicognizione
                              :key="'d' + ind"
                              :patient="patient"
                              type="terapie"
                              :template="template.template.ricognizione"
                              @schema-ricognizione="
                                setRicognizioneQuestions($event)
                              "
                            ></CompilatoreRicognizione>

                            <template v-if="schemaRicognizione">
                              <b-row
                                v-for="(therapy, index) in schemaRicognizione"
                                class="px-2 mt-2"
                                :key="index + 'ricognizione' + ind"
                              >
                                <h6
                                  class="text-left bg-primary text-white fw-bolder p-2 w-100"
                                >
                                  <span class="bg-secondary p-2"
                                    >Terapia {{ index + 1 }}.</span
                                  >
                                  {{ therapy[0].a }}
                                </h6>
                                <b-col>
                                  <b-row cols="1" cols-md="2">
                                    <b-col v-for="(field, position) in therapy" :key="position">
                                      <b-form-group
                                        class="text-left"
                                        :key="'terpos' + position"
                                      >
                                        <label>{{ field.q }}:</label>
                                        <template v-if="field.t === 'select'">
                                          <b-form-select
                                            class="shadow_6 align-self-center"
                                            v-model="
                                              schemaRicognizione[index][
                                                position
                                              ].a
                                            "
                                            :name="'ric_' + index"
                                            required
                                          >
                                            <b-form-select-option
                                              v-for="opt in field.o"
                                              :key="opt"
                                              :value="opt"
                                              >{{ opt }}
                                            </b-form-select-option>
                                            <b-form-select-option
                                              :value="null"
                                              disabled
                                              >scegli..
                                            </b-form-select-option>
                                          </b-form-select>
                                        </template>
                                        <template
                                          v-else-if="field.t === 'datetime'"
                                        >
                                          <b-form-input
                                            v-if="field.i"
                                            class="shadow_6"
                                            type="text"
                                            placeholder="GG/MM/AAAA hh:mm"
                                            :name="'ric_' + index"
                                            v-model="
                                              schemaRicognizione[index][
                                                position
                                              ].a
                                            "
                                            :readonly="field.i == false"
                                            v-bind="
                                              field.r && field.i !== false
                                                ? { required: true }
                                                : {}
                                            "
                                          ></b-form-input>
                                          <b-form-input
                                            v-else
                                            class="shadow_6"
                                            type="text"
                                            placeholder="GG/MM/AAAA hh:mm"
                                            :name="'ric_' + index"
                                            v-model="
                                              schemaRicognizione[index][
                                                position
                                              ].a
                                            "
                                            v-bind="
                                              field.r ? { required: true } : {}
                                            "
                                          ></b-form-input>
                                        </template>
                                        <b-form-input
                                          v-else
                                          class="shadow_6"
                                          :type="field.t"
                                          v-model="
                                            schemaRicognizione[index][position]
                                              .a
                                          "
                                          :readonly="field.i == false"
                                          v-bind="
                                            field.r && field.i !== false
                                              ? { required: true }
                                              : {}
                                          "
                                          :name="'ric_' + index"
                                        ></b-form-input>
                                      </b-form-group>
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </template>
                            <b-spinner
                              v-else
                              :key="'spinner-ricognizione-' + groupindex + '-' + ind"
                              :label="$t('caricamento')"
                            ></b-spinner>
                          </template>
                          <template
                            v-if="domanda.o === 'ricognizione_patologie'"
                          >
                            <CompilatoreRicognizione
                              :key="'d' + ind"
                              :patient="patient"
                              type="patologie"
                              :template="
                                template.template.ricognizione_patologie
                              "
                              @schema-ricognizione="
                                setRicognizionePatologieQuestions($event)
                              "
                            ></CompilatoreRicognizione>

                            <template v-if="schemaRicognizionePatologie">
                              <b-row
                                v-for="(
                                  pathology, index
                                ) in schemaRicognizionePatologie"
                                class="px-2 mt-2"
                                :key="index + 'ricognizione_pat' + ind"
                              >
                                <h6
                                  class="text-left bg-primary text-white fw-bolder p-2 w-100"
                                >
                                  <span
                                    class="bg-secondary p-2"
                                    :key="pathology[0].a"
                                    >Patologia {{ index + 1 }}.</span
                                  >
                                  {{ pathology[0].a }}
                                </h6>
                                <b-col>
                                  <b-row cols="1" cols-md="2">
                                    <b-col
                                      v-for="(field, position) in pathology"
                                      :key="'patpos' + position"
                                    >
                                      <b-form-group
                                        class="text-left"
                                        
                                      >
                                        <label>{{ field.q }}:</label>
                                        <template v-if="field.t === 'select'">
                                          <b-form-select
                                            class="shadow_6 align-self-center"
                                            v-model="
                                              schemaRicognizionePatologie[
                                                index
                                              ][position].a
                                            "
                                            :name="'ric_' + index"
                                            required
                                          >
                                            <b-form-select-option
                                              v-for="opt in field.o"
                                              :key="opt"
                                              :value="opt"
                                              >{{ opt }}
                                            </b-form-select-option>
                                            <b-form-select-option
                                              :value="null"
                                              disabled
                                              >scegli..
                                            </b-form-select-option>
                                          </b-form-select>
                                        </template>
                                        <template
                                          v-else-if="field.t === 'datetime'"
                                        >
                                          <b-form-input
                                            v-if="field.i"
                                            class="shadow_6"
                                            type="text"
                                            placeholder="GG/MM/AAAA hh:mm"
                                            :name="'ric_' + index"
                                            v-model="
                                              schemaRicognizionePatologie[
                                                index
                                              ][position].a
                                            "
                                            :readonly="field.i == false"
                                            v-bind="
                                              field.r && field.i !== false
                                                ? { required: true }
                                                : {}
                                            "
                                          ></b-form-input>
                                          <b-form-input
                                            v-else
                                            class="shadow_6"
                                            type="text"
                                            placeholder="GG/MM/AAAA hh:mm"
                                            :name="'ric_' + index"
                                            v-model="
                                              schemaRicognizionePatologie[
                                                index
                                              ][position].a
                                            "
                                            v-bind="
                                              field.r ? { required: true } : {}
                                            "
                                          ></b-form-input>
                                        </template>
                                        <b-form-input
                                          v-else
                                          class="shadow_6"
                                          :type="field.t"
                                          v-model="
                                            schemaRicognizionePatologie[index][
                                              position
                                            ].a
                                          "
                                          :readonly="field.i == false"
                                          v-bind="
                                            field.r && field.i !== false
                                              ? { required: true }
                                              : {}
                                          "
                                          :name="'ric_' + index"
                                        ></b-form-input>
                                      </b-form-group>
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </template>
                            <b-spinner
                              v-else
                              :key="'spinner-ricognizione-patologie-' + groupindex + '-' + ind"
                              :label="$t('caricamento')"
                            ></b-spinner>
                          </template>

                          <template v-if="domanda.o && domanda.o === 'file'">
                            <b-row cols="1" class="mb-3" :key="'file-' + groupindex + '-' + ind">
                              <b-col cols="12" class="text-justify">
                                <h6 :for="'q_' + ind">
                                  <span class="text-secondary">
                                    {{ groupindex + 1 }}.{{ ind + 1 }}
                                  </span>
                                  {{ domanda.q }}
                                  <span
                                    v-if="domanda.h"
                                    class="mb-0 text-secondary"
                                  >
                                    - domanda per l'operatore</span
                                  >
                                </h6>
                              </b-col>
                              <b-col cols="12" class="text-justify">
                                <b-form-group :key="'fgr_' + ind">
                                  <div class="align-self-center">
                                    <SurveyUploader
                                      v-on:upload-result="
                                        handleUpload($event, ind)
                                      "
                                      v-on:remove-result="removeUpload(ind)"
                                      :accepts="domanda.fa"
                                      :isMulti="domanda.fm"
                                    />
                                  </div>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </template>
                          <template
                            v-else-if="Array.isArray(domanda.o) && domanda.cb"
                          >
                            <b-row cols="1" class="mb-3" :key="'d' + ind">
                              <b-col
                                cols="12"
                                class="text-justify"
                                :key="'qq_' + ind"
                              >
                                <h6>
                                  <span class="text-secondary">
                                    {{ groupindex + 1 }}.{{ ind + 1 }}
                                  </span>
                                  {{ domanda.q }}
                                  <span
                                    v-if="domanda.h"
                                    class="mb-0 text-secondary"
                                  >
                                    - domanda per l'operatore</span
                                  >
                                </h6>
                              </b-col>
                              <b-col cols="12" class="text-justify">
                                <b-form-group :key="'tfgr_' + ind">
                                  <b-form-checkbox-group
                                    :name="'q_' + ind"
                                    v-model="domanda.a"
                                    :options="domanda.o"
                                  ></b-form-checkbox-group>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </template>
                        </template>
                        <template
                          v-if="
                            (Array.isArray(domanda.o) && !domanda.cb) ||
                            !domanda.o
                          "
                        >
                          <b-row cols="1" class="mb-3" :key="'dom' + ind">
                            <b-col cols="12" class="text-justify">
                              <h6 :for="'q_' + ind">
                                <span class="text-secondary">
                                  {{ groupindex + 1 }}.{{ ind + 1 }}
                                </span>
                                {{ domanda.q }}
                                <span
                                  v-if="domanda.h"
                                  class="mb-0 text-secondary"
                                >
                                  - domanda per l'operatore</span
                                >
                              </h6>
                            </b-col>
                            <b-col cols="12" class="text-justify">
                              <InputCompilatore
                                :identifier="'inputidentifier_' + ind"
                                :key="'inputidentifier_' + ind"
                                :question="domanda"
                                :index="ind"
                                :show-question="true"
                                @question-response="
                                  blockGroups[groupindex][ind].a = $event
                                "
                              />
                            </b-col>
                          </b-row>
                        </template>
                      </template>
                    </template>
                  </b-tab>
                </template>
              </b-tabs>
            </template>
            <b-col class="my-4 py-2" key="btsubmt">
              <b-row class="justify-content-center">
                <b-button
                  class="mx-2"
                  variant="outline-secondary"
                  :disabled="tabInView === 0"
                  @click="--tabInView"
                  >Indietro</b-button
                >

                <b-button
                  @click="sendForm"
                  variant="secondary fw-bolder spacing_1"
                  v-if="tabInView == template.block_number - 1"
                   :disabled="invalid"
                >
                  Invia</b-button
                >
                <template v-else>
                  <b-button class="mx-2" @click="moveOn" :disabled="invalid">Avanti</b-button>
                </template>
              </b-row>
            </b-col>
          </transition-group>
        </b-row>
      </b-form>
      </ValidationObserver>
    </div>
    <b-modal
      id="errori_compilazione"
      centered
      title="Attenzione!"
      ok-title="OK"
      ok-variant="popup-button"
      footer-border-variant="white"
      ok-only
    >
      <div class="my-3 px-2">
        <h5>{{ errorMessage }}</h5>
      </div>
    </b-modal>
  </div>
</template>
<script>
import SurveyUploader from "@/app/common/components/utilities/SurveyUploader.vue";
import CompilatoreRicognizione from "@/app/modules/servizi/screening/components/compilatore/CompilatoreRicognizione.vue";
import InputCompilatore from "@/app/modules/servizi/screening/components/compilatore/InputCompilatore.vue";
import { ValidationObserver } from 'vee-validate';
import * as surveyFlow from "@/_utils/survey_flow";
export default {
  name: "CompilatoreQuestionarioInBlocks",
  props: ["survey", "patient"],
  components: { SurveyUploader, CompilatoreRicognizione, InputCompilatore, ValidationObserver },
  data() {
    return {
      template: null,
      consent: false,
      proceed: false,
      file: null,
      tempTag: null,
      hasFocus: null,
      schemaRicognizione: null,
      schemaRicognizionePatologie: null,
      blockGroups: [],
      tabInView: 0,
      errorMessage: null,
      canScrollLeft: false,
      canScrollRight: false,
      pillsOverflow: false,
    };
  },
  watch: {
    tabInView() {
      this.scrollActivePillIntoView();
    },
  },
  methods: {
    onFileChange(e) {
      this.file = e.target.files[0];
    },
    sendForm() {
      if(this.currentBlockIsValid()) {
        this.template.template.ricognizione = this.schemaRicognizione;
        this.template.template.ricognizione_patologie = this.schemaRicognizionePatologie;
        this.$emit("filled-form", this.template);
        //console.log('valid')
      }
    },
    handleUpload(data, ind) {
      if (this.template.template.domande[ind].a == null) {
        this.template.template.domande[ind].a = [];
      }
      this.template.template.domande[ind].a.push(data.hashid);
      if (Array.isArray(data)) {
        this.template.template.domande[ind].a = data.map((el) => el.hashid);
      }
    },
    removeUpload(ind) {
      this.template.template.domande[ind].a = null;
    },
    addCustom(ind) {
      this.template.template.domande[ind].a.push(this.tempTag);
      this.tempTag = null;
    },
    setRicognizioneQuestions(data) {
      this.schemaRicognizione = data;
    },
    setRicognizionePatologieQuestions(data) {
      this.schemaRicognizionePatologie = data;
    },
    canBeShown(domanda) {
      // return true;
      if (!domanda.si && !domanda.hi) {
        return true;
      }
      //TO DO: correggere perchè al momento le risposte le sto mettendo in blockGroups non direttamente in template.template
      // Confronto per inclusione: gestisce le multiselect (risposta array)
      if (
        domanda.si &&
        surveyFlow.matchesResponse(
          this.template.template.domande[domanda.si.index].a,
          domanda.si.response
        )
      ) {
        return (
          !domanda.hi ||
          (domanda.hi &&
            !surveyFlow.matchesResponse(
              this.template.template.domande[domanda.hi.index].a,
              domanda.hi.response
            ))
        );
      }
      return false;
    },
    setupBlocks(template) {
      for (let x = 1; x <= template.block_number; x++) {
        var block = this.template.template.domande.filter((el) => el.bn == x);
        this.blockGroups.push(block);
      }
      // ricalcola lo stato di overflow una volta renderizzate le pill dei blocchi
      this.$nextTick(() => this.updateScrollState());
    },
    blockTitle(groupindex) {
      const blockRules =
        this.template && this.template.template
          ? this.template.template.block_rules
          : null;
      return surveyFlow.getBlockTitle(
        blockRules,
        groupindex + 1,
        "Gruppo " + (groupindex + 1)
      );
    },
    moveOn() {
      if(this.currentBlockIsValid()) {
        ++this.tabInView;
      }
    },
    goBack() {
      if (this.tabInView > 0) {
        --this.tabInView;
      }
    },
    goToBlock(groupindex) {
      // Spostamento massimo di un blocco per volta: in avanti si passano gli
      // stessi controlli del pulsante "successivo", indietro come "precedente".
      const delta = groupindex - this.tabInView;
      if (delta === 1) {
        this.moveOn();
      } else if (delta === -1) {
        this.goBack();
      }
    },
    isPillDisabled(groupindex, invalid) {
      const delta = groupindex - this.tabInView;
      // Blocco corrente e precedente sempre raggiungibili.
      if (delta === 0 || delta === -1) {
        return false;
      }
      // Blocco successivo raggiungibile solo se il blocco corrente è valido.
      if (delta === 1) {
        return invalid;
      }
      // Salti di più di un blocco non consentiti.
      return true;
    },
    getPillsList() {
      return this.$el ? this.$el.querySelector('.block-pills-list') : null;
    },
    scrollActivePillIntoView() {
      this.$nextTick(() => {
        const nav = this.getPillsList();
        if (!nav) return;
        const active = nav.querySelector('[aria-current]');
        const target = active && active.closest('.block-pill-item');
        if (!target) return;
        // mantiene il blocco attivo sempre visibile, anche con molti blocchi
        target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    },
    // i chevron scorrono la striscia dei blocchi (non navigano tra i blocchi)
    scrollPills(direction) {
      const list = this.getPillsList();
      if (!list) return;
      const step = Math.max(120, Math.round(list.clientWidth * 0.75));
      list.scrollBy({ left: direction * step, behavior: 'smooth' });
    },
    scrollPillsLeft() {
      this.scrollPills(-1);
    },
    scrollPillsRight() {
      this.scrollPills(1);
    },
    updateScrollState() {
      const list = this.getPillsList();
      if (!list) {
        this.canScrollLeft = false;
        this.canScrollRight = false;
        this.pillsOverflow = false;
        return;
      }
      const maxScroll = list.scrollWidth - list.clientWidth;
      // overflow reale: le pill eccedono il container, quindi ha senso scorrere
      this.pillsOverflow = maxScroll > 1;
      this.canScrollLeft = list.scrollLeft > 1;
      this.canScrollRight = list.scrollLeft < maxScroll - 1;
    },
    currentBlockIsValid() {
      const questionGroup = this.blockGroups[this.tabInView];
      for (let x = 0; x < questionGroup.length; x++) {
        // Salta le domande non visibili (condizione si/hi non soddisfatta)
        if (!this.canBeShown(questionGroup[x])) {
          continue;
        }
        if (questionGroup[x].o != "ricognizione_patologie" && questionGroup[x].o != "ricognizione") {
          if (questionGroup[x].ric && questionGroup[x].ric.index != null) {
            const isRequired = typeof questionGroup[questionGroup[x].ric.index].a === "string" &&
              typeof questionGroup[x].ric.value === "string" &&
              questionGroup[questionGroup[x].ric.index].a?.toLowerCase() ===
              questionGroup[x].ric.value?.toLowerCase();
            if (isRequired && surveyFlow.isAnswerEmpty(questionGroup[x].a)) {
              this.errorMessage = `Compila il campo obbligatorio per la domanda n°${
                x + 1
              }:"${questionGroup[x].q}"`;
              this.$bvModal.show("errori_compilazione");
              return false;
            }
          } else if (questionGroup[x].r && surveyFlow.isAnswerEmpty(questionGroup[x].a)) {
            this.errorMessage = `Compila il campo obbligatorio per la domanda n°${
              x + 1
            }:"${questionGroup[x].q}"`;
            this.$bvModal.show("errori_compilazione");
            return false;
          }
        }
        else {
          let questionsRicognizionePatologie = [];
          if (questionGroup[x].o == "ricognizione_patologie") {
            questionsRicognizionePatologie = this.schemaRicognizionePatologie
          }
          else if(questionGroup[x].o == "ricognizione") {
            questionsRicognizionePatologie = this.schemaRicognizione
          }
          for (let y = 0; y < questionsRicognizionePatologie.length; y++) {
            for(var i in questionsRicognizionePatologie[y]) {
              //console.log(i)
              //console.log(questionsRicognizionePatologie[y][i])
            
              if (questionsRicognizionePatologie[y][i].ric && questionsRicognizionePatologie[y][i].ric.index) {
                  const isRequired = typeof questionsRicognizionePatologie[questionsRicognizionePatologie[y].ric.index][i].a === "string" &&
                    typeof questionsRicognizionePatologie[y][i].ric.value === "string" &&
                    questionsRicognizionePatologie[questionsRicognizionePatologie[y].ric.index][i].a?.toLowerCase() ===
                    questionsRicognizionePatologie[y][i].ric.value?.toLowerCase();
                  if (isRequired && surveyFlow.isAnswerEmpty(questionsRicognizionePatologie[y][i].a)) {
                    this.errorMessage = `Compila il campo obbligatorio per la domanda n°${
                      x + 1
                    }:"${questionsRicognizionePatologie[y][i].q}"`;
                    this.$bvModal.show("errori_compilazione");
                    return false;
                  }
              } else if (questionsRicognizionePatologie[y][i].r && surveyFlow.isAnswerEmpty(questionsRicognizionePatologie[y][i].a)) {
                this.errorMessage = `Compila il campo obbligatorio per la domanda n°${
                  x + 1
                }:"${questionsRicognizionePatologie[y][i].q}"`;
                this.$bvModal.show("errori_compilazione");
                return false;
              }
            }
          }
        }
      }
      return true;
    },
  },
  created() {
    if (this.survey) {
      try {
        this.template = this.survey;
        this.setupBlocks(this.survey);
      } catch (err) {
        console.log(err);
      }
    }
  },
  mounted() {
    this.scrollActivePillIntoView();
    this.$nextTick(() => {
      const list = this.getPillsList();
      if (list) {
        list.addEventListener('scroll', this.updateScrollState, { passive: true });
      }
      window.addEventListener('resize', this.updateScrollState);
      this.updateScrollState();
    });
  },
  beforeDestroy() {
    const list = this.getPillsList();
    if (list) {
      list.removeEventListener('scroll', this.updateScrollState);
    }
    window.removeEventListener('resize', this.updateScrollState);
  },
};
</script>

<style scoped>
/* il compilatore resta entro la larghezza disponibile e non allarga i container della pagina:
   essendo spesso figlio di contenitori flex, serve min-width:0 per poter rimpicciolire */
.compilatore-blocchi {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}
/* il nav è flex container: così la lista diventa un flex item scroll-container e,
   con min-width:0, contribuisce 0 alla larghezza minima → non allarga i container padre */
.block-pills-nav {
  display: flex;
  max-width: 100%;
  min-width: 0;
}
/* striscia blocchi: pill separate, scorrevoli orizzontalmente con blocco attivo sempre visibile */
.block-pills-list {
  flex: 1 1 auto;
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5rem;
  list-style: none;
  margin: 0;
  max-width: 100%;
  min-width: 0;
  /* padding verticale: lo scroll orizzontale taglierebbe bordo e alone di focus delle pill */
  padding: 0.5rem 0.25rem;
  overflow-x: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  /* scorrimento mantenuto, scrollbar nascosta */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Edge/IE legacy */
}
.block-pills-list::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Edge */
}
.block-pill-item {
  flex: 0 0 auto;
}
.block-pill-item .btn {
  white-space: nowrap;
}
/* pulsanti circolari di navigazione tra blocchi (precedente/successivo) */
.block-nav-arrow {
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
